import "./CoefCalculator.scss";
import Calc from "assets/icons/calculator.svg";
import arrow from "assets/icons/arrow.svg";
import InputText from "core/inputs/input-text/InputText";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import { VAR_TYPES } from "constants/constants";
import InfoContext from "pages/InfoContext";
import { useContext, useState } from "react";
import _ from "lodash";

const CoefCalculator = () => {
  const { getCalculateCoefX, coefCalculatorResult } = useContext(InfoContext);
  const [inputValue, setInputValue] = useState("");

  return (
    <div className="mission-coef">
      <img src={Calc} alt="coef-salaire" className="calculator" />
      <Typography
        className="title-4 violet"
        type="p"
        label={
          <FormattedMessage
            id="calculate_coefx"
            defaultMessage="Calculer coeff X"
          />
        }
      />
      <InputText
        id="input-coefx-calculator"
        onChange={(e) => {
          setInputValue(e.target.value);
          getCalculateCoefX({ amount: e.target.value });
        }}
        placeholder={{
          id: "input_coefx_calculator",
          defaultMessage: "Saisir le salaire brut",
        }}
        type={VAR_TYPES.NUMBER}
      />
      <img src={arrow} alt="" className="arrow" />
      <Typography
        className="title-5 light-slate-gray result"
        type="p"
        label={
          !coefCalculatorResult?.amount || !inputValue ? (
            <FormattedMessage
              id="result_coefx_calculator"
              defaultMessage={"Coeff X"}
            />
          ) : (
            coefCalculatorResult?.amount
          )
        }
      />
      <Typography
        className="title-5 light-slate-gray"
        type="p"
        label={
          inputValue &&
          coefCalculatorResult?.ratio && (
            <>
              {"("}
              <FormattedMessage
                id="ratio_coefx_calculator"
                defaultMessage={"Mean X"}
              />
              {" = "}
              {_.round(coefCalculatorResult?.ratio, 5)}
              {")"}
            </>
          )
        }
      />
    </div>
  );
};

export default CoefCalculator;
